import styles from './Footer.module.css';

type Props = { email?: string | undefined; social: { label: string; url: string }[] };

export function Footer({ email, social }: Props) {
  return (
    <footer className={styles.footer}>
      {email && (
        <a className={styles.email} href={`mailto:${email}`}>
          {email}
        </a>
      )}
      <ul className={styles.social}>
        {social.map((s) => (
          <li key={s.url}>
            <a href={s.url} target="_blank" rel="noreferrer">
              {s.label}
            </a>
          </li>
        ))}
      </ul>
      <p className={styles.copy}>© {new Date().getFullYear()}</p>
    </footer>
  );
}
